/*
    Excel Parsing Layout Configuration
    Defines cell mappings for different calibration file formats.
*/

export const ExcelLayouts = {
    MASTER_METER_V1: {
        label: "Master Meter V1 (2024)",
        description: "Formato estándar Master Meter 2024",
        head: {
            Fecha: "C7",
            Compania: "D11",
            Planta: "D5",
            MesaCarga: "C15",
            Brazo: "E15",
            Producto: "D12",
            Ambientacion: "C16",
            FactorMM: "G15",
            Tipo_Flujo: "E14",
            // Extras
            BrutoInicial: "D9",
            BrutoFinal: "F9",
            NetoInicial: "D10",
            NetoFinal: "F10",
            FactorInicial: "D13",
            FactorFinal: "J13"
        },
        // Details Configuration
        details: {
            startRow: 41,    // Excel row number (1-based)
            endRow: 44,      // Excel row number
            validationRow: 36, // Row to check for non-empty value (optional)
            columns: [
                { id: "D", loadIdx: 1 },
                { id: "E", loadIdx: 2 },
                { id: "F", loadIdx: 3 },
                { id: "G", loadIdx: 4 },
                { id: "H", loadIdx: 5 },
                { id: "I", loadIdx: 6 },
                { id: "J", loadIdx: 7 },
                { id: "K", loadIdx: 8 }
            ],
            // Maps the data relative to the column and row index
            // Relative row offsets from 'startRow' (0, 1, 2, 3) are assumed.
            // standard order: 
            // Row 0 (startRow): ErrorVolumenBruto
            // Row 1: ErrorVolumenNeto
            // Row 2: DifVolBruto
            // Row 3: DifVolNeto
            rowsMap: [
                "ErrorVolumenBruto",
                "ErrorVolumenNeto",
                "DifVolBruto",
                "DifVolNeto"
            ]
        }
    },

    MASTER_METER_V2: {
        label: "Master Meter V2 (2025)",
        description: "Formato actualizado Master Meter 2025",
        head: {
            Fecha: "C4",
            Compania: "C7",
            Planta: "C8",
            MesaCarga: "G7",
            Brazo: "G8",
            Producto: "K7",
            Ambientacion: "K10",
            FactorMM: "K11",
            Tipo_Flujo: "G4",
            // Extras
            BrutoInicial: "C10",
            BrutoFinal: "C11",
            NetoInicial: "C12",
            NetoFinal: "C13",
            FactorInicial: "G12",
            FactorFinal: "G13"
        },
        details: {
            startRow: 41,
            endRow: 44,
            validationRow: 36,
            columns: [
                { id: "D", loadIdx: 1 },
                { id: "E", loadIdx: 2 },
                { id: "F", loadIdx: 3 },
                { id: "G", loadIdx: 4 },
                { id: "H", loadIdx: 5 },
                { id: "I", loadIdx: 6 },
                { id: "J", loadIdx: 7 },
                { id: "K", loadIdx: 8 }
            ],
            rowsMap: [
                "ErrorVolumenBruto",
                "ErrorVolumenNeto",
                "DifVolBruto",
                "DifVolNeto"
            ]
        }
    },

    PATRON_VOLUMETRICO: {
        label: "Patron Volumetrico V1 (2024)",
        description: "Calibración con Patrón Volumétrico",
        head: {
            Fecha: "C7",
            Compania: "D11",
            Planta: "D5",
            MesaCarga: "C15",
            Brazo: "E15",
            Producto: "D12",
            Ambientacion: "C16",
            FactorMM: "G15",
            Tipo_Flujo: "E14",
            // Extras
            BrutoInicial: "D9",
            BrutoFinal: "F9",
            NetoInicial: "D10",
            NetoFinal: "F10",
            FactorInicial: "D13",
            FactorFinal: "J13"
        },
        details: {
            startRow: 40,   // Shifted by -1 compared to MM V1
            endRow: 43,
            validationRow: 35,
            columns: [
                { id: "D", loadIdx: 1 },
                { id: "E", loadIdx: 2 },
                { id: "F", loadIdx: 3 },
                { id: "G", loadIdx: 4 },
                { id: "H", loadIdx: 5 },
                { id: "I", loadIdx: 6 },
                { id: "J", loadIdx: 7 },
                { id: "K", loadIdx: 8 }
            ],
            rowsMap: [
                "ErrorVolumenBruto",
                "ErrorVolumenNeto",
                "DifVolBruto",
                "DifVolNeto"
            ]
        }
    },

    // Placeholder if needed for Patron V2, currently clone of V1
    PATRON_VOLUMETRICO_V2: {
        label: "Patron Volumetrico V2",
        description: "Versión 2 (Configurable)",
        head: {
            Fecha: "C7",
            Compania: "D11",
            Planta: "D5",
            MesaCarga: "C15",
            Brazo: "E15",
            Producto: "D12",
            Ambientacion: "C16",
            FactorMM: "G15",
            Tipo_Flujo: "E14"
        },
        details: {
            startRow: 40,
            endRow: 43,
            validationRow: 35,
            columns: [
                { id: "D", loadIdx: 1 },
                { id: "E", loadIdx: 2 },
                { id: "F", loadIdx: 3 },
                { id: "G", loadIdx: 4 },
                { id: "H", loadIdx: 5 },
                { id: "I", loadIdx: 6 },
                { id: "J", loadIdx: 7 },
                { id: "K", loadIdx: 8 }
            ],
            rowsMap: [
                "ErrorVolumenBruto",
                "ErrorVolumenNeto",
                "DifVolBruto",
                "DifVolNeto"
            ]
        }
    }
};
